export const COUNTRY_CODES = [
  "MX", "US", "CA", "GT", "SV", "HN", "NI", "CR", "PA", "CU", "DO", "PR", "CO", "VE", "EC", "PE", "BO", "CL", "AR", "UY", "PY", "BR",
  "ES", "PT", "FR", "IT", "DE", "GB", "IE", "NL", "BE", "CH", "AT", "SE", "NO", "DK", "FI", "PL", "CZ", "HR", "GR", "RU", "UA", "TR",
  "JP", "KR", "CN", "TW", "PH", "IN", "TH", "VN", "ID", "MY", "SG", "AU", "NZ", "ZA", "EG", "MA", "IL", "AE", "SA",
];

export const flagOf = (code) => (code && code.length === 2 ? String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt(0))) : "");

export const countryName = (code, lang) => {
  if (!code) return "";
  try {
    return new Intl.DisplayNames([lang], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
};

export const TURTLES = {
  leo: { name: "Leonardo", color: "#3b82f6" },
  raph: { name: "Raphael", color: "#ef4444" },
  donnie: { name: "Donatello", color: "#a855f7" },
  mikey: { name: "Michelangelo", color: "#f97316" },
};
